import { MFA_AUTH_ACTION } from '@actions/actions/authentication/mfa-auth-action';
import IpfsHash from 'ipfs-only-hash';
import { LitAbility, LitActionResource, LitPKPResource } from '@lit-protocol/auth-helpers';
import { ethers } from 'ethers';
import { ENV_LIT_NETWORK, LIT_RPC_URL } from '@shared/utils/config/environment';
import { getLitContractClient } from './litContract';
import { getAuthId } from './getAuthId';
export const getMFAActionId = async (pkp, sessionSig) => {
  const litContractClient = await getLitContractClient(pkp.publicKey, sessionSig);
  const litActionHash = await IpfsHash.of(MFA_AUTH_ACTION);
  return litContractClient.utils.getBytesFromMultihash(litActionHash);
};
export const checkMFA = async (pkp, sessionSig, currentAuthMethod) => {
  try {
    console.log('WUJI Start checkMFA');
    const _mfaInfo = {};
    let startTime = new Date().toISOString();
    const result = await fetch('/api/auth/mfa-info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await result.json();
    console.log('WUJI checkMFA 0', data, new Date().getTime() - new Date(startTime).getTime());
    startTime = new Date().toISOString();
    if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
      _mfaInfo.presentMFAInfo = {
        authMethodType: data.mfaInfo.auth_method_type,
        authId: data.mfaInfo.auth_id,
        providerValue: data.mfaInfo.provider_value
      };
    }
    const litContractClient = await getLitContractClient(pkp.publicKey, sessionSig);
    console.log('WUJI checkMFA 1', new Date().getTime() - new Date(startTime).getTime());
    startTime = new Date().toISOString();
    const authId = await getAuthId(currentAuthMethod, pkp, sessionSig);
    console.log('WUJI checkMFA 2 ', new Date().getTime() - new Date(startTime).getTime());
    startTime = new Date().toISOString();
    _mfaInfo.scopes = await litContractClient.pkpPermissionsContract.read.getPermittedAuthMethodScopes(pkp.tokenId, currentAuthMethod.authMethodType, authId, 3);
    console.log('WUJI checkMFA 3', new Date().getTime() - new Date(startTime).getTime());
    console.log('WUJI End checkMFA', _mfaInfo);
    return _mfaInfo;
  } catch (e) {
    console.log('WUJI Error in checkMFA', e);
    return null;
  }
};
export const getMFASessionSig = async (pkp, currentAuthMethod, MFAAuthMethod, litNodeClient, sessionLength, litSession, setMFAProgress) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  try {
    const mfaauthresponse = await litNodeClient.executeJs({
      code: MFA_AUTH_ACTION,
      sessionSigs: litSession,
      jsParams: {
        tokenId: (_a = ethers.BigNumber.from(pkp.tokenId)) === null || _a === void 0 ? void 0 : _a.toHexString(),
        publicKey: pkp.publicKey,
        auth1: {
          authId: await getAuthId(currentAuthMethod, pkp, litSession),
          authMethodType: (_b = currentAuthMethod.authMethodType) === null || _b === void 0 ? void 0 : _b.toString()
        },
        auth2: {
          authId: await getAuthId(MFAAuthMethod, pkp, litSession),
          authMethodType: (_c = MFAAuthMethod.authMethodType) === null || _c === void 0 ? void 0 : _c.toString()
        },
        sigName: 'mfa-auth-sig-lit-action'
      }
    });
    setMFAProgress && setMFAProgress(50);
    console.log('getMFASessionSig==  mfaauthresponse', mfaauthresponse, litSession);
  } catch (e) {
    console.log('getMFASessionSig== ispermit', e, LIT_RPC_URL, ENV_LIT_NETWORK, litSession, MFA_AUTH_ACTION, {
      tokenId: (_d = ethers.BigNumber.from(pkp.tokenId)) === null || _d === void 0 ? void 0 : _d.toHexString(),
      publicKey: pkp.publicKey,
      auth1: {
        authId: await getAuthId(currentAuthMethod, pkp, litSession),
        authMethodType: (_e = currentAuthMethod.authMethodType) === null || _e === void 0 ? void 0 : _e.toString()
      },
      auth2: {
        authId: await getAuthId(MFAAuthMethod, pkp, litSession),
        authMethodType: (_f = MFAAuthMethod.authMethodType) === null || _f === void 0 ? void 0 : _f.toString()
      }
    });
  }
  console.log('getMFASessionSig== ', pkp.publicKey);
  setMFAProgress && setMFAProgress(75);
  if (currentAuthMethod && MFAAuthMethod) {
    const litActionSessionSigs = await litNodeClient.getLitActionSessionSigs({
      litActionCode: (_g = Buffer.from(MFA_AUTH_ACTION)) === null || _g === void 0 ? void 0 : _g.toString('base64'),
      pkpPublicKey: pkp.publicKey,
      expiration: new Date(Date.now() + sessionLength * 1000).toISOString(),
      resourceAbilityRequests: [{
        resource: new LitPKPResource('*'),
        ability: LitAbility.PKPSigning
      }, {
        resource: new LitActionResource('*'),
        ability: LitAbility.LitActionExecution
      }],
      jsParams: {
        tokenId: (_h = ethers.BigNumber.from(pkp.tokenId)) === null || _h === void 0 ? void 0 : _h.toHexString(),
        publicKey: pkp.publicKey,
        auth1: {
          authId: await getAuthId(currentAuthMethod, pkp, litSession),
          authMethodType: (_j = currentAuthMethod.authMethodType) === null || _j === void 0 ? void 0 : _j.toString()
        },
        auth2: {
          authId: await getAuthId(MFAAuthMethod, pkp, litSession),
          authMethodType: (_k = MFAAuthMethod.authMethodType) === null || _k === void 0 ? void 0 : _k.toString()
        },
        sigName: 'mfa-auth-sig-session-sigs'
      }
    });
    console.log('MFASessionSigs=>', litActionSessionSigs);
    setMFAProgress && setMFAProgress(100);
    return litActionSessionSigs;
  }
  return null;
};